import settings from '@/settings'
import axios from 'axios'
import { CLIENT_QUERY_TIMEOUT } from '@/constants'
// eslint-disable-next-line import/no-webpack-loader-syntax
import ChallengeWorker from './challenge.worker.js'

const client = axios.create({
  baseURL: `https://${settings.get('POW_HOST')}`,
  timeout: CLIENT_QUERY_TIMEOUT,
  responseType: 'json'
})

const solveChallenge = (challenge) => new Promise((resolve, reject) => {
  const worker = new ChallengeWorker()

  worker.addEventListener('message', (event) => {
    resolve(event.data)
    worker.terminate()
  })
  worker.addEventListener('error', (error) => {
    reject(error)
  })
  worker.postMessage({ challenge })
})

const getChallenge = async () => {
  const { data: challengeData } = await client.get('/challenge/')

  return solveChallenge(challengeData)
}

export const powInterceptor = async (config) => {
  if (config.proofOfWork !== true) {
    return config
  }

  try {
    const challenge = await getChallenge()

    config.headers[settings.get('POW_ID_HEADER', 'X-Pow-Id')] = challenge.id
    config.headers[settings.get('POW_RESULT_HEADER', 'X-Pow-Result')] = challenge.result

    return config
  } catch (error) {
    Logger.error(error)
    return config
  }
}
